<template>
  <div class="con-wrap">
    <div v-if="changeCon" class="list-con full-page">
      <el-form
        size="medium"
        :inline="true"
        :model="queryForm"
        ref="queryForm"
        class="input-form-inline"
        @submit.native.prevent
      >
        <div>
          <el-form-item class="r-20" prop="vehicleModel">
            <el-input
              v-model="queryForm.vehicleModel"
              @keyup.enter.native="query"
              placeholder="车辆型号"
            ></el-input>
          </el-form-item>
          <el-button
            v-if="hasPerm('vehicle:model:list')"
            type="primary"
            @click="query"
            >查询</el-button
          >
          <el-button v-if="hasPerm('vehicle:model:list')" @click="reset"
            >取消</el-button
          >
        </div>

        <div style="margin-bottom: 20px">
          <el-button
            v-if="hasPerm('vehicle:model:save')"
            type="primary"
            @click="addOrder"
            >新增</el-button
          >
          <el-button
            size="medium"
            v-if="hasPerm('vehicle:model:delete')"
            type="danger"
            @click.native="delModel"
            >删除</el-button
          >
        </div>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        stripe
        height="560px"
        @row-click="handleClickTableRow"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="24"
          align="center"
          style="padding: 0"
        ></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="vehicleModel" label="车辆型号"></el-table-column>
        <el-table-column prop="modelCode" label="车辆编码"></el-table-column>
        <el-table-column
          prop="enterpriseName"
          label="企业名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="displacement" label="排量(ml)"></el-table-column>
        <el-table-column prop="fuelTypes" label="燃料种类">
          <template slot-scope="scope">
            <span v-if="scope.row.fuelTypes == 1">汽油</span>
            <span v-else-if="scope.row.fuelTypes == 2">柴油</span>
            <span v-else-if="scope.row.fuelTypes == 3">电动</span>
            <span v-else-if="scope.row.fuelTypes == 4">混动</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="vehicleNum"
          label="车辆总数(辆)"
        ></el-table-column>
        <el-table-column
          prop="vehicleBindNum"
          label="绑定车主数量(辆)"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              v-if="hasPerm('vehicle:model:update')"
              @click.stop="editModel(scope.row)"
              >修改</el-button
            >
            <el-button
              size="mini"
              type="text"
              v-if="hasPerm('vehicle:model:info')"
              @click.stop="clickModelInfo(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <!-- 详情弹窗 -->
      <el-dialog
        title="车型基本信息"
        :visible.sync="infoVisible"
        class="mini-dialog info-box"
      >
        <p class="dialog-title">型号信息</p>
        <div style="padding: 0 40px; margin-bottom: 10px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">车辆型号</el-col>
              <el-col :span="17">{{ ModelInfo.vehicleModel }}</el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">车辆编码</el-col>
              <el-col :span="17">{{ ModelInfo.modelCode }}</el-col>
            </el-col>
          </el-row>
        </div>
        <p class="dialog-title">生产企业信息</p>
        <div style="padding: 0 40px; margin-bottom: 10px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">车辆名称</el-col>
              <el-col :span="17">{{ ModelInfo.vehicleName }}</el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">中文品牌</el-col>
              <el-col :span="17">{{ ModelInfo.brand }}</el-col>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">公告型号</el-col>
              <el-col :span="17">{{ ModelInfo.noticeModel }}</el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">企业名称</el-col>
              <el-col :span="17">{{ ModelInfo.enterpriseName }}</el-col>
            </el-col>
          </el-row>
        </div>
        <p class="dialog-title">主要技术参数</p>
        <div style="padding: 0 40px; margin-bottom: 10px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">外形尺寸</el-col>
              <el-col :span="17">
                {{ ModelInfo.length }}×{{ ModelInfo.wide }}×{{ ModelInfo.high }}
                <span>(mm)</span>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">总质量</el-col>
              <el-col :span="17">
                {{ ModelInfo.totalQuality }}
                <span>(kg)</span>
              </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">整备质量</el-col>
              <el-col :span="17">
                {{ ModelInfo.wholeQuality }}
                <span>(kg)</span>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">额定载客</el-col>
              <el-col :span="17">
                {{ ModelInfo.ratedPassenger }}
                <span>(人)</span>
              </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">轴距</el-col>
              <el-col :span="17">
                {{ ModelInfo.wheelbase }}
                <span>(mm)</span>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">最高车速</el-col>
              <el-col :span="17">
                {{ ModelInfo.maSpeed }}
                <span>(km/h)</span>
              </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">轴数</el-col>
              <el-col :span="17">{{ ModelInfo.axleNumber }}</el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">弹簧片数</el-col>
              <el-col :span="17">{{ ModelInfo.springNumber }}</el-col>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">轮胎数</el-col>
              <el-col :span="17">{{ ModelInfo.tyreNumber }}</el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">轮胎规格</el-col>
              <el-col :span="17">{{ ModelInfo.tyreSpecs }}</el-col>
            </el-col>
          </el-row>
        </div>
        <p class="dialog-title">发动机参数</p>
        <div style="padding: 0 40px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">发动机</el-col>
              <el-col :span="17">{{ ModelInfo.engine }}</el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">发动机生产企业</el-col>
              <el-col :span="17">{{ ModelInfo.engineCreateEnterprise }}</el-col>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">排量</el-col>
              <el-col :span="17">
                {{ ModelInfo.displacement }}
                <span>(ml)</span>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">功率</el-col>
              <el-col :span="17">
                {{ ModelInfo.power }}
                <span>(kw)</span>
              </el-col>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">功率</el-col>
              <el-col :span="17">
                {{ ModelInfo.power }}
                <span>(kw)</span>
              </el-col>
            </el-col>
          </el-row> -->
        </div>
        <p class="dialog-title">车辆燃料参数</p>
        <div style="padding: 0 40px; margin-bottom: 10px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">燃料类型</el-col>
              <el-col :span="17">{{ ModelInfo.fuelTypes }}</el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">依据标准</el-col>
              <el-col :span="17">{{ ModelInfo.basisStandard }}</el-col>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-col :span="7" class="dialog-label">底盘排放标准</el-col>
              <el-col :span="17">{{ ModelInfo.chassisLetoutStand }}</el-col>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
    <div v-else class="add-con">
      <add-model
        :modelForm="modelForm"
        :editTag="editTag"
        @child-change="getChangeCon"
      ></add-model>
    </div>
  </div>
</template>

<script>
import AddModel from "./components/AddModel.vue"
export default {
  components: {
    AddModel,
  },
  data() {
    return {
      changeCon: true,
      queryForm: {
        vehicleModel: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      // tableHeight: 0,
      tableData: [],
      tableVal: [],
      orderInfoData: {},
      infoVisible: false,
      modelForm: {},
      ModelInfo: {},
      typeList: [
        {
          name: "汽油",
          value: 1,
        },
        {
          name: "柴油",
          value: 2,
        },
        {
          name: "电动",
          value: 3,
        },
        {
          name: "混动",
          value: 4,
        },
      ],
      dischargeList: [
        {
          name: "国一",
          value: 1,
        },
        {
          name: "国二",
          value: 2,
        },
        {
          name: "国三",
          value: 3,
        },
        {
          name: "国四",
          value: 4,
        },
        {
          name: "国五",
          value: 5,
        },
        {
          name: "国六",
          value: 6,
        },
      ],
    }
  },
  created() {
    this.getModelList()
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.tableHeight = window.innerHeight - 400; //后面的50：根据需求空出的高度，自行调整
    // });
  },
  methods: {
    getChangeCon(data) {
      this.getModelList()
      this.changeCon = data
    },
    async getModelList() {
      let obj = {
        limit: this.limit,
        page: this.currentPage,
        vehicleModel: this.queryForm.vehicleModel,
      }
      let _this = this
      let { data: res } = await _this.$axios.get("/api/vehicle/model/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    query() {
      this.getModelList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.getModelList()
    },
    addOrder() {
      this.changeCon = false
      this.editTag = "0"
      this.modelForm = {}
      // this.$router.push("/AddOrder")
    },

    async delModel() {
      let _this = this
      //多选删除
      let ids = _this.$getIds(_this.tableVal)
      if (!ids) {
        return
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/vehicle/model", {
            data: JSON.stringify(ids),
          })
          if (res.code == 1) {
            _this.$message.success("操作成功")
            let totalPage = Math.ceil((_this.total - 1) / 10)
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage
            _this.currentPage = currentPage < 1 ? 1 : currentPage
            _this.getModelList()
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val
    },
    handleClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getModelList()
    },
    //修改
    async editModel(rowData) {
      this.modelForm = {}
      let id = rowData.id
      console.log(rowData.id)
      this.getModelInfo(id)
      this.changeCon = false
      this.editTag = "1"
    },
    //列表详情弹窗内容
    async getModelInfo(id) {
      //显示弹框
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/model/info/" + id
      )
      if (res.code == 1) {
        this.modelForm = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async clickModelInfo(rowData) {
      this.infoVisible = true
      let id = rowData.id
      //显示弹框
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/model/info/" + id
      )
      if (res.code == 1) {
        _this.ModelInfo = res.data
        for (let index in _this.dischargeList) {
          console.log(index + "--" + _this.dischargeList[index].name)
          if (_this.ModelInfo.chassisLetoutStand == index) {
            _this.ModelInfo.chassisLetoutStand = _this.dischargeList[index].name
          }
        }
        for (let index in _this.typeList) {
          if (_this.ModelInfo.fuelTypes == index) {
            _this.ModelInfo.fuelTypes = _this.typeList[index].name
          }
        }
      } else {
        _this.$message.warning(res.msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap > div {
  height: 100%;
  overflow: auto;
}
.top {
  height: 48px;
  line-height: 48px;
  display: block;
  margin-bottom: 20px;
  padding-left: 20px;
  background-color: #fff;
}
.full-page {
  padding: 0 20px;
  background: #fff;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
//详情弹窗样式
.info-box /deep/ .el-dialog {
  width: 900px;
}
.info-box /deep/ .el-dialog__body {
  color: #333;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.dialog-label {
  font-weight: bold;
}
.info-box /deep/ .el-row {
  line-height: 34px;
}
</style>
